<template>
  <div>
    <div v-if="presentation && currentState">
      <div>
        <mdb-btn v-if="currentState.status == 'Running'"
                 aria-label="Next" icon="arrow-left"
                 size="lg" title="Previous"
                 @click.native="controls.cardChange(presentation,'previous')"/>
        <mdb-btn v-if="currentState.status == 'Running'"
                 icon="arrow-right" size="lg"
                 @click.native="controls.cardChange(presentation,'next')"/>
      </div>
      <div>
        <mdb-btn v-if="currentState && !currentState.openToUser && currentState.status == 'Running'
                                       && (currentState.type == 'QC' || currentState.type=='QF')"
                 aria-label="Let Them Answer"
                 color="warning" icon="question"
                 size="lg" title="Let Them Answer"
                 @click.native="controls.openToAnswer(presentation,true)"/>
        <mdb-btn v-if="currentState &&
                                       !currentState.openToUser && currentState.status == 'Running'
                                       && currentState.type == 'SR'" aria-label="Show the Reveal"
                 color="warning" icon="presentation"
                 size="log" title="Show the Reveal"
                 @click.native="controls.openToAnswer(presentation,true)"/>
        <mdb-btn v-if="currentState.status == 'Running'"
                 aria-label="Call on someone..." color="warning" icon="hand-point-up"
                 size="lg" title="Call on someone"
                 @click.native="callOnDialog()"/>
      </div>
      <div>

        <mdb-btn v-if="currentState.status == 'Running'"
                 aria-label="Restart" icon="step-backward" size="lg"
                 title="Restart" @click.native="controls.cardChange(presentation,'start')"/>
        <mdb-btn v-if="currentState.status == 'Running'"
                 aria-label="Last Page" icon="step-forward" size="lg"
                 title="Last Page" @click.native="controls.cardChange(presentation,'end')"/>
      </div>
      <div>
        <mdb-btn v-if="currentState.status != 'Paused'"
                 aria-label="Pause" color="green" icon="pause"
                 size="lg" title="Pause" @click.native="controls.togglePause(presentation)"/>
        <mdb-btn v-if="currentState.status == 'Paused'"
                 aria-label="Resume" color="yellow" icon="play"
                 size="lg" title="Resume" @click.native="controls.togglePause(presentation)"/>
      </div>
      <div>
        <mdb-btn aria-label="Leave/Quit" color="red" icon="portal-exit"
                 size="lg"
                 title="Leave/Quit" @click.native="$emit('terminate')"
        />
      </div>

    </div>
    <div v-if="!presentation || !currentState">
      <mdb-spinner/>
    </div>

    <mdb-modal v-if="showCallOnDialog" class="text-center"
               info scrollable size="lg" @close="showCallOnDialog = false">
      <mdb-modal-header class="secondary-color">
        <h4>Call On Someone</h4>
      </mdb-modal-header>
      <mdb-modal-body>
        <div v-if="lastCalledOn" class="info-text">You last called on {{ lastCalledOn.name }}</div>
        <mdb-btn v-for="(a,i) in currentState.attendees" :key="i" icon="check" @click="callOn(a)">{{ a.name }}</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

  </div>
</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {mdbBtn, mdbModal, mdbModalBody, mdbModalHeader, mdbSpinner} from 'mdbvue';
import presentationControls from "../../services/presentationControls";

export default {
  name: "presentation-viewer",
  components: {
    mdbBtn,
    mdbSpinner,
    mdbModal,
    mdbModalHeader,
    mdbModalBody
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
    currentUser() {
      return this.$store.state.userDetails
    },
    settings() {
      return this.$store.state.settings
    }
  },
  data() {
    return {
      controls: null,
      showCallOnDialog: false,
      lastCalledOn: null,
    }
  },
  mounted() {
    this.controls = presentationControls
  },
  props: {
    presentation: {
      type: Object,
      default: null
    },
    currentState: {
      type: Object,
      default: null
    },
    standalone: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    callOnDialog() {
      this.showAllControls = false
      this.showCallOnDialog = true
    },
    callOn(att) {
      this.lastCalledOn = att
      this.showCallOnDialog = false
      api.post("/presentationViewer/callOnParticipant/" + this.$route.params.sessionId, {
        token: this.presentation.accessToken, participant: att
      }).then(
        () => {

        },
        (error) => {
          this.answered = false
          this.$notify.error({message: error.response.data, timeOut: 5000})
        })
    },
  }
};

</script>
<style scoped>
.jumbo-page {
  display: block;
  overflow: auto;
}

</style>
